<template>
  <v-container fluid row class="ma-0 mb-4 pa-0" style="overflow-x:auto; overflow-y:auto">
    <v-layout wrap row>
      <v-flex
        xs12
        lg4
        md6
        style=" position:relative"
        :class="{'pr-0': $vuetify.breakpoint.xsOnly, 'pr-4': $vuetify.breakpoint.mdAndUp}"
      >
        <h2 class="pb-2">Participants</h2>
        <v-flex
          xs12
          pa-4
          mt-2
          style="background:rgba(230,230,230,1); height:300px; overflow:auto; border-radius:3px;"
          :class="{'mb-4': $vuetify.breakpoint.smAndDown, 'mb-0': $vuetify.breakpoint.mdAndUp}"
        >
          <v-flex xs12 pb-3>
            <span style="vertical-align:middle;opacity:0.7">Click minus icon to remove participants.</span>
          </v-flex>
          <TeamAvatar
            :name="team.displayName"
            :team-id="team.id"
            display-cancel
            v-for="(team) in selectedTeams"
            :key="teamId(team.id)"
            @clickedRemove="clickedRemove"
          ></TeamAvatar>
          <UserAvatar
            :name="user.displayName"
            :user-id="user.id"
            display-cancel
            v-for="(user) in selectedUsers"
            :key="userId(user.id)"
            @clickedRemove="clickedRemove"
          ></UserAvatar>
          <v-icon
            size="40"
            color="secondary"
            style="position:absolute; right:-20px; top:180px;"
            class="hidden-sm-and-down"
          >swap_horiz</v-icon>
        </v-flex>
      </v-flex>
      <v-flex
        xs12
        lg8
        md6
        :class="{'pl-0': $vuetify.breakpoint.xsOnly, 'pl-4': $vuetify.breakpoint.mdAndUp}"
      >
        <v-layout row wrap>
          <v-layout wrap row>
            <v-flex xs10>
              <v-checkbox
                class="mb-2 mr-2"
                style="display:inline-block; margin-top:5px;"
                color="secondary"
                label="Teams"
                v-model="teamsCheckbox"
              ></v-checkbox>
              <v-checkbox
                class="mb-2"
                color="secondary"
                label="Individuals"
                v-model="individualCheckbox"
                style="display:inline-block;margin-top:5px;"
              ></v-checkbox>
            </v-flex>
            <v-flex xs2>
              <v-tooltip top color="secondary">
                <v-btn
                  slot="activator"
                  class="mr-0 text-xs-right"
                  flat
                  icon
                  style="float:right"
                  v-on:click="sortDirection = !sortDirection"
                >
                  <v-icon color="secondary">{{ sortDirection ? 'arrow_upward' : 'arrow_downward' }}</v-icon>
                </v-btn>
                <span>Toggle ASC/DESC order</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
          <v-flex sm12>
            <v-text-field
              box
              clearable
              append-icon="search"
              color="secondary"
              clear-icon="cancel"
              label="Search..."
              class="hidden-md-and-up"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout style="margin-top:-2px">
          <v-flex
            xs12
            px-4
            pb-4
            pt-4
            mt-2
            style="margin-top:-4px !important;float:left; background:rgba(230,230,230,1); height:300px; overflow:auto; border-radius:3px;"
          >
            <v-flex xs12 pb-3>
              <span style="vertical-align:middle; opacity:0.7">Click plus icon to add participants.</span>
            </v-flex>
            <div v-if="teamsCheckbox">
              <TeamAvatar
                :name="team.displayName"
                :team-id="team.id"
                display-add
                v-for="(team) in totalAvailableTeams"
                :key="teamId(team.id)"
                @clickedAdd="clickedAdd"
              ></TeamAvatar>
            </div>
            <div v-if="individualCheckbox">
              <UserAvatar
                :name="user.displayName"
                :user-id="user.id"
                display-add
                v-for="(user) in totalAvailableUsers"
                :key="userId(user.id)"
                @clickedAdd="clickedAdd"
              ></UserAvatar>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import UserAvatar from "@/components/Users/UserAvatar.vue"
import TeamAvatar from "@/components/teams/TeamAvatar.vue"

const participantSort = (a, b) => {
  if (a.displayName > b.displayName) {
    return 1
  }
  if (a.displayName < b.displayName) {
    return -1
  }
  if (a.displayName === b.displayName) {
    return 0
  }
}
const participantRevereSort = (a, b) => participantSort(b, a)

export default {
  name: "participants-panel",
  components: { UserAvatar, TeamAvatar },
  props: {
    participatingTeams: Array,
    participatingUsers: Array,
    availableTeams: Array,
    availableUsers: Array
  },
  data: () => ({
    sortDirection: true,
    individualCheckbox: true,
    teamsCheckbox: true,
    participants: [],
    nonParticipants: [],
    searchToggled: false,
    pendingAddUsers: [],
    pendingAddTeams: [],
    pendingRemoveUsers: [],
    pendingRemoveTeams: [],
    showShareDialog: false,
    searchQuery: "",
    orderBy: ""
  }),
  computed: {
    selectedUsers() {
      let selectedUsers = []
      selectedUsers = selectedUsers.concat(this.participatingUsers || [])
      selectedUsers = selectedUsers.concat(this.pendingAddUsers || [])
      if (this.pendingRemoveUsers && this.pendingRemoveUsers.length > 0) {
        const selectedUserIds = this.pendingRemoveUsers.map(t => t.id)
        selectedUsers = selectedUsers.filter(
          t => !selectedUserIds.find(sui => sui === t.id)
        )
      }
      return selectedUsers
    },
    selectedTeams() {
      let selectedTeams = []
      selectedTeams = selectedTeams.concat(this.participatingTeams || [])
      selectedTeams = selectedTeams.concat(this.pendingAddTeams || [])
      if (this.pendingRemoveTeams && this.pendingRemoveTeams.length > 0) {
        const selectedTeamIds = this.pendingRemoveTeams.map(t => t.id)
        selectedTeams = selectedTeams.filter(
          t => !selectedTeamIds.find(sti => sti === t.id)
        )
      }
      return selectedTeams
    },
    totalAvailableUsers() {
      const newlySelected = this.pendingAddUsers.map(u => u.id)
      let previouslySelected = []
      if (this.participatingUsers) {
        previouslySelected = this.participatingUsers.map(u => u.id)
      }
      let totalAvailableUsers = []
      totalAvailableUsers = totalAvailableUsers.concat(this.availableUsers)
      totalAvailableUsers = totalAvailableUsers.filter(
        u =>
          !newlySelected.find(id => id === u.id) &&
          !previouslySelected.find(id => id === u.id)
      )
      totalAvailableUsers = totalAvailableUsers.concat(this.pendingRemoveUsers)
      if (
        this.individualCheckbox &&
        this.searchQuery &&
        this.searchQuery.length > 0
      ) {
        totalAvailableUsers = totalAvailableUsers.filter(u =>
          u.displayName.toLowerCase().startsWith(this.searchQuery.toLowerCase())
        )
      }
      if (this.sortDirection) {
        totalAvailableUsers = totalAvailableUsers.sort(participantSort)
      } else {
        totalAvailableUsers = totalAvailableUsers.sort(participantRevereSort)
      }
      return totalAvailableUsers
    },
    totalAvailableTeams() {
      let previouslySelected = []
      let totalAvailableTeams = []
      const newlySelected = this.pendingAddTeams.map(u => u.id)
      if (this.participatingTeams) {
        previouslySelected = this.participatingTeams.map(t => t.id)
      }
      totalAvailableTeams = totalAvailableTeams.concat(this.availableTeams)
      totalAvailableTeams = totalAvailableTeams.filter(
        t =>
          !newlySelected.find(id => id === t.id) &&
          !previouslySelected.find(id => id === t.id)
      )
      totalAvailableTeams = totalAvailableTeams.concat(this.pendingRemoveTeams)
      if (
        this.teamsCheckbox &&
        this.searchQuery &&
        this.searchQuery.length > 0
      ) {
        totalAvailableTeams = totalAvailableTeams.filter(t =>
          t.displayName.toLowerCase().startsWith(this.searchQuery.toLowerCase())
        )
      }
      if (this.sortDirection) {
        totalAvailableTeams = totalAvailableTeams.sort(participantSort)
      } else {
        totalAvailableTeams = totalAvailableTeams.sort(participantRevereSort)
      }
      return totalAvailableTeams
    }
  },
  methods: {
    teamId(id) {
      return `t${id}`
    },
    userId(id) {
      return `u${id}`
    },
    clickedAdd(participant) {
      if (participant.type === "user") {
        const existingIdx = this.pendingRemoveUsers.findIndex(
          u => u.id === participant.user.id
        )
        if (existingIdx >= 0) {
          this.pendingRemoveUsers.splice(existingIdx, 1)
        } else {
          this.pendingAddUsers.push(participant.user)
        }
      } else {
        const existingIdx = this.pendingRemoveTeams.findIndex(
          t => t.id === participant.team.id
        )
        if (existingIdx >= 0) {
          this.pendingRemoveTeams.splice(existingIdx, 1)
        } else {
          this.pendingAddTeams.push(participant.team)
        }
      }
      this.sendUpdates()
    },
    clickedRemove(participant) {
      if (participant.type === "user") {
        const existingIdx = this.pendingAddUsers.findIndex(
          u => u.id === participant.user.id
        )
        if (existingIdx >= 0) {
          this.pendingAddUsers.splice(existingIdx, 1)
        } else {
          this.pendingRemoveUsers.push(participant.user)
        }
      } else {
        const existingIdx = this.pendingAddTeams.findIndex(
          t => t.id === participant.team.id
        )
        if (existingIdx >= 0) {
          this.pendingAddTeams.splice(existingIdx, 1)
        } else {
          this.pendingRemoveTeams.push(participant.team)
        }
      }
      this.sendUpdates()
    },
    sendUpdates() {
      const data = {
        pendingAddUsers: this.pendingAddUsers,
        pendingRemoveUsers: this.pendingRemoveUsers,
        pendingAddTeams: this.pendingAddTeams,
        pendingRemoveTeams: this.pendingRemoveTeams
      }
      this.$emit("pending-update", data)
    }
  }
}
</script>
